// Lightweight i18n
export const translations = {
  en: {
    appName: "ServeOn",
    tagline: "Every Service, One Platform",
    login: "Log in", signup: "Sign up", logout: "Log out",
    email: "Email", password: "Password", name: "Full name", phone: "Phone",
    continue: "Continue", search: "Search", searchPh: "Search restaurants, cuisines...",
    home: "Home", orders: "Orders", wallet: "Wallet", profile: "Profile",
    cart: "Cart", checkout: "Checkout", placeOrder: "Place order",
    addToCart: "Add to cart", viewCart: "View cart",
    subtotal: "Subtotal", deliveryFee: "Delivery fee", tax: "Tax", total: "Total",
    deliverTo: "Deliver to", paymentMethod: "Payment method",
    cash: "Cash on delivery", walletPay: "Wallet", card: "Card",
    orderPlaced: "Order placed!", trackOrder: "Track order",
    pending: "Pending", confirmed: "Confirmed", preparing: "Preparing",
    ready: "Ready", picked_up: "Picked up", out_for_delivery: "On the way", delivered: "Delivered",
    dashboard: "Dashboard", menu: "Menu", subscription: "Subscription",
    serviceModules: "Service Modules", users: "Users", restaurants: "Restaurants",
    everyService: "Every Service.", onePlatform: "One Platform.",
    heroSub: "The all-in-one platform for Sudan — order food, book services, and grow your business, all in one app.",
    getStarted: "Get Started", exploreRestaurants: "Explore Restaurants", exploreServices: "Explore Services",
    welcomeBack: "Welcome back",
    role_customer: "Customer", role_restaurant_owner: "Restaurant", role_rider: "Rider", role_admin: "Admin",
    iAmA: "I am a",
    addBalance: "Add balance", topUp: "Top up",
    earnings: "Earnings", deliveries: "Deliveries", online: "Online", offline: "Offline",
    goOnline: "Go online", goOffline: "Go offline",
    availableJobs: "Available jobs", accept: "Accept", advance: "Advance status",
    addMenuItem: "Add menu item", price: "Price", category: "Category", description: "Description",
    chooseRestaurant: "Choose your restaurant", emptyCart: "Your cart is empty",
    rating: "Rating", reviews: "reviews", minOrder: "Min order",
    featured: "Featured", browseAll: "Browse all",
    loyaltyPoints: "Loyalty points", tier: "Tier",
    notifications: "Notifications", markAllRead: "Mark all read",
    plans: "Subscription plans", monthly: "Monthly", yearly: "Yearly",
    subscribe: "Subscribe", currentPlan: "Current plan",
    adminStats: "Platform overview",
    gmv: "GMV", subRevenue: "Subscription revenue",
    yourOrders: "Your orders", noOrders: "No orders yet",
    leaveReview: "Leave a review", submitReview: "Submit review",
    comingSoon: "Coming Soon", joinWaitlist: "Join waitlist",
  },
  ar: {
    appName: "سيرف أون",
    tagline: "كل خدمة، منصة واحدة",
    login: "تسجيل الدخول", signup: "إنشاء حساب", logout: "تسجيل الخروج",
    email: "البريد الإلكتروني", password: "كلمة المرور", name: "الاسم الكامل", phone: "الهاتف",
    continue: "متابعة", search: "بحث", searchPh: "ابحث عن مطاعم، مأكولات...",
    home: "الرئيسية", orders: "الطلبات", wallet: "المحفظة", profile: "حسابي",
    cart: "السلة", checkout: "إتمام الطلب", placeOrder: "تأكيد الطلب",
    addToCart: "أضف للسلة", viewCart: "عرض السلة",
    subtotal: "المجموع الفرعي", deliveryFee: "رسوم التوصيل", tax: "الضريبة", total: "الإجمالي",
    deliverTo: "التوصيل إلى", paymentMethod: "طريقة الدفع",
    cash: "كاش عند التوصيل", walletPay: "المحفظة", card: "بطاقة",
    orderPlaced: "تم استلام الطلب!", trackOrder: "تتبع الطلب",
    pending: "قيد المراجعة", confirmed: "مؤكد", preparing: "قيد التحضير",
    ready: "جاهز", picked_up: "تم الاستلام", out_for_delivery: "في الطريق", delivered: "تم التوصيل",
    dashboard: "لوحة التحكم", menu: "القائمة", subscription: "الاشتراك",
    serviceModules: "وحدات الخدمات", users: "المستخدمون", restaurants: "المطاعم",
    everyService: "كل خدمة.", onePlatform: "منصة واحدة.",
    heroSub: "منصة موحدة لكل السودان — اطلب الطعام، احجز الخدمات، ونمّي أعمالك في تطبيق واحد.",
    getStarted: "ابدأ الآن", exploreRestaurants: "اكتشف المطاعم", exploreServices: "اكتشف الخدمات",
    welcomeBack: "أهلاً بعودتك",
    role_customer: "عميل", role_restaurant_owner: "مطعم", role_rider: "سائق", role_admin: "إدارة",
    iAmA: "أنا",
    addBalance: "إضافة رصيد", topUp: "شحن الرصيد",
    earnings: "الأرباح", deliveries: "التوصيلات", online: "متصل", offline: "غير متصل",
    goOnline: "اتصل الآن", goOffline: "اقطع الاتصال",
    availableJobs: "الطلبات المتاحة", accept: "قبول", advance: "تقدم في الحالة",
    addMenuItem: "إضافة صنف", price: "السعر", category: "الفئة", description: "الوصف",
    chooseRestaurant: "اختر مطعمك", emptyCart: "السلة فارغة",
    rating: "التقييم", reviews: "تقييم", minOrder: "أقل طلب",
    featured: "مميز", browseAll: "تصفح الكل",
    loyaltyPoints: "نقاط الولاء", tier: "المستوى",
    notifications: "الإشعارات", markAllRead: "تحديد الكل كمقروء",
    plans: "خطط الاشتراك", monthly: "شهري", yearly: "سنوي",
    subscribe: "اشترك", currentPlan: "الخطة الحالية",
    adminStats: "نظرة عامة",
    gmv: "إجمالي المبيعات", subRevenue: "إيرادات الاشتراكات",
    yourOrders: "طلباتك", noOrders: "لا توجد طلبات بعد",
    leaveReview: "اترك تقييمًا", submitReview: "إرسال التقييم",
    comingSoon: "قريبًا", joinWaitlist: "انضم لقائمة الانتظار",
  },
};

export const useT = (lang) => (key) => translations[lang]?.[key] ?? key;
